import { useContext } from 'react';

import { getApprovalKeyword } from '@atom/components/common/requests/customTenantUtilities';
import { AssetRequestStatus } from '@atom/types/assetRequest';
import { getDisplayDateTime } from '@atom/utilities/timeUtilities';
import { getUserFullName } from '@atom/utilities/userUtilities';

import ViewRequestContext from '../ViewRequestContext';

import classes from './adotView.module.css';

const ADOTApprovalDisplay = () => {
  const { activeRequest } = useContext(ViewRequestContext);

  const approvalKeyword = getApprovalKeyword(activeRequest?.status);
  const approvalKeywordSuffix = approvalKeyword === 'Approve' ? 'd' : 'ed';

  const isApproved =
    activeRequest?.status === AssetRequestStatus.FULL_APPROVAL ||
    activeRequest?.status === AssetRequestStatus.PARTIAL_APPROVAL;

  const timestampText = `${approvalKeyword}${approvalKeywordSuffix} by ${getUserFullName(
    activeRequest?.updatedBy,
  )} on ${getDisplayDateTime(
    activeRequest?.resolutionDate ?? activeRequest?.updatedDate,
  )}`;

  return (
    <div className={classes.approvalForm} data-cy="adotTransferApprovalDisplay">
      <div
        className={classes.formTitle}
      >{`Request ${approvalKeyword}${approvalKeywordSuffix}`}</div>
      {isApproved && (
        <div className={classes.viewRow}>
          <div className={classes.rowTitle}>{`Approved Quantity (${
            activeRequest?.assetUnit || ''
          })`}</div>
          <div>{activeRequest?.quantityApproved}</div>
        </div>
      )}
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Comments</div>
        <div>{activeRequest?.comments}</div>
      </div>
      <div className={classes.createdSubtext}>{timestampText}</div>
    </div>
  );
};

export default ADOTApprovalDisplay;
